import api from "./api";
import auth from "./auth";

const getDetails = () => {
    return new Promise((resolve, reject) => {
        api.get("/merchant-service/cms/details", auth.getHeader())
            .then(response => resolve(response))
            .catch(e => reject(e.errors));
    });
};

const updateDetails = payload => {
    return new Promise((resolve, reject) => {
        api.post(
            "/merchant-service/cms/details/update",
            payload,
            auth.getHeader()
        )
            .then(response => resolve(response))
            .catch(e => reject(e.errors));
    });
};

const getDocuments = () => {
    return new Promise((resolve, reject) => {
        api.get("/merchant-service/cms/documents", auth.getHeader())
            .then(response => resolve(response))
            .catch(e => reject(e.errors));
    });
};

const updateDocuments = payload => {
    return new Promise((resolve, reject) => {
        api.post(
            "/merchant-service/cms/documents/update",
            payload,
            auth.getHeader()
        )
            .then(response => resolve(response))
            .catch(e => reject(e.errors));
    });
};

const getApplicationDetails = () => {
    return new Promise((resolve, reject) => {
        api.get("/merchant-service/cms/application/details", auth.getHeader())
            .then(response => resolve(response))
            .catch(e => reject(e.errors));
    });
};

const updateApplicationDetails = payload => {
    return new Promise((resolve, reject) => {
        api.post(
            "/merchant-service/cms/application/details/update",
            payload,
            auth.getHeader()
        )
            .then(response => resolve(response))
            .catch(e => reject(e.errors));
    });
};

const viewMeta = payload => {
    return new Promise((resolve, reject) => {
        api.post(
            "/merchant-service/cms/settings/meta/view",
            payload,
            auth.getHeader()
        )
            .then(response => resolve(response))
            .catch(e => reject(e.errors));
    });
};
const updateMeta = payload => {
    return new Promise((resolve, reject) => {
        api.post(
            "/merchant-service/cms/settings/meta/update",
            payload,
            auth.getHeader()
        )
            .then(response => resolve(response))
            .catch(e => reject(e.errors));
    });
};

const getMaintenance = () => {
    return new Promise((resolve, reject) => {
      api
        .post("/merchant-service/cms/merchant/settings", { role: 'cms' }, auth.getHeader())
        .then((response) => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
};

const getModuleList = () => {
    return new Promise((resolve, reject) => {
        api.get("/merchant-service/cms/merchant/module/list", auth.getHeader())
            .then(response => resolve(response))
            .catch(e => reject(e.errors));
    });
};

export default {
    getDetails,
    updateDetails,
    getDocuments,
    updateDocuments,
    getApplicationDetails,
    updateApplicationDetails,
    viewMeta,
    updateMeta,
    getMaintenance,
    getModuleList
};
